import {Matrix4, Vector3} from "three";

/** Detail dimensions in the API are in mm; the module scene uses meters. */
export const MM_TO_M = 0.001;

/**
 * Отображение панели как у куба: из угла (0,0,0) оси +X/+Y/+Z идут внутрь.
 * Геометрия: ширина в +Y (мм), затем scale и rotateX(−π/2)
 * → локаль инстанса: +X длина, +Y толщина, −Z ширина.
 */
export const makePanelMeshLocalMatrix = (mmToM = MM_TO_M) => {
    const s = mmToM;
    return new Matrix4()
        .makeRotationX(-Math.PI / 2)
        .multiply(new Matrix4().makeScale(s, s, s));
};

/**
 * Угол панели в мм (X=длина, Y=ширина, Z=толщина) → локаль инстанса (м).
 * После поворота ширина направлена в −Z; перенос возвращает диапазон в 0…width.
 */
export const panelCornerMmToInstance = (
    xMm,
    yMm,
    zMm,
    mmToM = MM_TO_M,
    widthMm = 0,
) => {
    const v = new Vector3(
        Number(xMm) || 0,
        Number(yMm) || 0,
        Number(zMm) || 0,
    );
    v.applyMatrix4(makePanelMeshLocalMatrix(mmToM));
    v.z += (Number(widthMm) || 0) * mmToM;
    return v;
};
